export enum EMortgageRateHikeBannerActionTypes {
  Close = 'mortgageRateHikeBanner/close',
}

export interface ICloseMortgageRateHikeBannerAction {
  type: EMortgageRateHikeBannerActionTypes.Close;
}

export function closeMortgageRateHikeBanner(): ICloseMortgageRateHikeBannerAction {
  return {
    type: EMortgageRateHikeBannerActionTypes.Close,
  };
}
